import React from 'react';

import {ProductProps} from 'modules/products/types';
import Column from 'shared/components/column';
import {RegularText, SemiBoldText} from 'shared/components/text';
import styled from 'styled-components';
import ProductPrice from 'modules/products/components/product-price';
import {useNavigate} from 'react-router-dom';

const Product: React.FC<ProductProps> = (props) => {
  const {id, name, description, image} = props;
  const navigate = useNavigate();

  return (
    <Container onClick={() => navigate(id, {state: props})}>
      <Column gap={10} style={{flex: 1}}>
        <SemiBoldText>{name}</SemiBoldText>
        {description ? (
          <RegularText numberOfLines={2} size="small">
            {description}
          </RegularText>
        ) : null}
        <ProductPrice {...props} />
      </Column>
      {image && <ProductImage src={image} />}
    </Container>
  );
};

export default Product;

export const Container = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: calc(50% - 15px);

  padding: 15px 20px;
  gap: 10px;
  border-radius: 4px;
  border: 1px solid rgba(128, 128, 128, 0.3);

  box-shadow: 0px 1px 1.41px rgba(0, 0, 0, 0.2);

  background: none;
  cursor: pointer;
`;

export const ProductImage = styled.img`
  width: 140px;
  height: 110px;
  border-radius: 6px;
  object-fit: cover;
`;
